import React, { useEffect, useState } from "react";
import Header from "./header/header";
import Footer from "./footer/footer";
import Form from "./form/form";
import axios from "axios";

function Index() {
  const [configData, setConfigData] = useState({});
  useEffect(() => {
    axios
      .get("/arp-api/v1/site/config")
      .then(function (response) {
        setConfigData(response?.data);
      })
      .catch(function (e) {
        console.log("error while fetching config");
      });
  }, []);
  return (
    <>
      <Header />
      <Form configData={configData} />
      <Footer configData={configData} />
    </>
  );
}

export default Index;
